import { atom } from "jotai";

import { Account } from "../types";

// We need a way to read currentAccountId from within jotai.
export const currentAccountIdAtom = atom<number | undefined>(undefined);

export const accountAtom = atom<Account | null>(null);
accountAtom.debugLabel = `accountAtom`;
